module.exports = __webpack_public_path__ + "static/media/chart-placeholder-icon.bc84cc0c.png";